import React__default from 'react';

var TableSliderComponent = function (_a) {
    var children = _a.children;
    return React__default.createElement("div", { className: 'pgc-lobby-slider' }, children);
};
var ImgItem = function (_a) {
    var src = _a.src, imgAlt = _a.imgAlt;
    return React__default.createElement("img", { src: src, alt: imgAlt });
};
var VideoItem = function (_a) {
    var src = _a.src;
    return React__default.createElement("video", { src: src, autoPlay: true, loop: true, muted: true });
};
var ItemsWr = function (_a) {
    var children = _a.children, isActive = _a.isActive, isPrev = _a.isPrev;
    return React__default.createElement("div", { className: "pgc-lobby-slide ".concat(isActive ? 'active' : '', " ").concat(isPrev ? 'prev' : '') }, children);
};
var TableSlider = Object.assign(TableSliderComponent, {
    ItemsWr: ItemsWr,
    VideoItem: VideoItem,
    ImgItem: ImgItem,
});

export { TableSlider };
